import { ResponseError } from '../../errors';
import {
  fetchPublicWebV1ReviewReply,
  TPublicWebV1ReviewReplyRequest,
  TPublicWebV1ReviewReplyResponse,
} from '../../repositories/dailyrent/web/v1/review/reply';
import { IApplicationContext } from '../../types/applicationContext';

interface IDailyrentCreateReplyArgs {
  context: IApplicationContext;
  parameters: TPublicWebV1ReviewReplyRequest;
}

export async function dailyrentCreateReply({ context, parameters }: IDailyrentCreateReplyArgs): Promise<void> {
  const { httpApi } = context;

  const result = (await fetchPublicWebV1ReviewReply({ httpApi, parameters })) as TPublicWebV1ReviewReplyResponse;

  if (result.statusCode !== 200) {
    throw new ResponseError({
      domain: 'reviews#fetchAddAnswer',
      message: 'Не удалось отправить ответ на отзыв.',
    });
  }
}
